import { Injectable } from '@angular/core';
import { BaseRepositoryService } from './base.service';
import { FunctionInterface } from '../model/function.model';

@Injectable({
  providedIn: 'root'
})
export class FunctionListGlobalService extends BaseRepositoryService<FunctionInterface>{
  override collectionPath: string = '/function';
  constructor() {
    super();
    this.query();
  }
}
